export const GROUP_BY_MY_GROUPS = "my_groups";
export const GROUP_BY_STATE = "state";

export function getOwnerGroupByOptions(isPublicReadOnly) {
  return [
    [
      GROUP_BY_MY_GROUPS,
      isPublicReadOnly ? "owner.groupBy.ownerGroups" : "owner.groupBy.myGroups",
      isPublicReadOnly ? "Owner's groups" : "My groups",
    ],
    ["country", "owner.groupBy.country", "Country"],
    ...(!isPublicReadOnly ? [[GROUP_BY_STATE, "owner.groupBy.state", "State"]] : []),
    ["none", "owner.groupBy.none", "None"],
  ];
}

export function normalizeOwnerGroupBy(groupBy, isPublicReadOnly) {
  const options = getOwnerGroupByOptions(isPublicReadOnly);
  return options.some(([value]) => value === groupBy) ? groupBy : GROUP_BY_MY_GROUPS;
}
